import * as types from '@/store/mutation-types';

const state = {
  globalAnnouncements: [],
};

const getters = {
  globalAnnouncements(state) {
    return state.globalAnnouncements;
  },
};

const mutations = {
  [types.ADD_GLOBAL_ANNOUNCEMENT](state, value) {
    state.globalAnnouncements.splice(0, 0, value);
  },
  [types.REMOVE_GLOBAL_ANNOUNCEMENT](state, index) {
    state.globalAnnouncements.splice(index, 1);
  },
};

const actions = {
  addGlobalAnnouncement({ commit }, params) {
    commit(types.ADD_GLOBAL_ANNOUNCEMENT, params);
  },
  removeGlobalAnnouncement({ commit }, params) {
    commit(types.REMOVE_GLOBAL_ANNOUNCEMENT, params);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
